import { SET_ACTIVE_TAB, RESET_FILTERS } from "../actions/agentsPaymentReducer";
import defaultFilters from '../../containers/agent/data/defaultFilters.json'
import get from 'lodash/get';

const initialState = {
  activeTab: 0,
  filtersTab0: [ ...get(defaultFilters, 'filtersTab0')],
  filterKey: Date.now()
}

export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch(type){
    case SET_ACTIVE_TAB:
      newState = { activeTab: payload }
      return { ...state, ...newState }
    case RESET_FILTERS:
      return { 
        ...state, 
        filtersTab0: [ ...get(defaultFilters, 'filtersTab0')],
        filterKey: Date.now()
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/agentsPaymentReducer.js